import Container from "@components/Container/Container";

/**
 * Component to render Description of E50 on homepage
 */
const E50Description = (): React.ReactElement => {
  return (
    <Container
      rootClassName="flex flex-row justify-center px-0"
      data-testid="e50-description-component"
    >
      <div className="mb-6 flex w-full flex-col justify-center pl-3 text-center text-gray-850 md:pl-4 lg:w-11/12 lg:flex-row">
        <div className="w-full lg:w-4/12 lg:pr-4">
          <h2 className="mb-6 text-left font-poppins text-xl font-medium md:mb-2 md:mb-6 lg:mb-0 lg:pl-3 lg:text-8xl lg:leading-tight">
            {"Future-Proof "}
            <br className="inline hidden lg:block" />
            {"Growth "}
            <br className="inline hidden lg:block" />
            {"Through "}
            <br className="inline hidden lg:block" />
            {"Innovation"}
          </h2>
        </div>

        <p className="text-md w-full pl-0 text-left font-public-sans leading-6 lg:w-8/12">
          This theme highlights the critical role of innovation as a catalyst
          for transformation, enabling companies to anticipate market shifts and
          proactively adjust their strategies. In a world where technological
          advancements such as artificial intelligence, digitalisation, and the
          Internet of Things redefine industries, &quot;Future-Proof Growth
          Through Innovation&quot; encourages businesses to foster a culture
          that promotes experimentation, continuous learning, and strategic
          agility. The 2026 E50 Awards sets the stage for recognising and
          celebrating enterprises, so if your company is making a meaningful
          impact on the economy and shaping the future of business, this is your
          opportunity to be recognised among the nation&apos;s top leaders.
        </p>
      </div>
    </Container>
  );
};

export default E50Description;
